import React, { useEffect, useState } from "react";
import functions from "../../../util/functions";
import FilterModal from "../../../components/filter/Modal";
import TabelaSimples from "../../../components/tabelas/simples";
import reqProdutoPdv from "../../../services/reqMultiTenant/reqProdutoPdv";
import reqPedidoItens from "../../../services/reqMultiTenant/reqPedidoItens";
import { ToastContainer } from "react-toastify";
import Notification from "../../../components/toast";
import HeaderReport from "../../../components/header/report";
import HeaderListFilter from "../../../components/header/report-filter";

function ProdutosDeletados() {
	const [isFilterOpen, setIsFilterOpen] = useState(false);
	const [dtini, setDtIni] = useState();
	const [dtfim, setDtFim] = useState();
	const [hrIni, setHrIni] = useState("00:00:00");
	const [hrFim, setHrFim] = useState("23:59:59");
	const [idCaixaOuColaborador, setIdCaixaOuColaborador] = useState("%");
	const [nomeColaboradorOuCaixa, setNomeOuColaborador] = useState("TODOS");
	const [isSelectCaixa, setIsSelectCaixa] = useState(true);
	const [loading, setLoading] = useState(false);
	const [onObservacoes, setOnObservacoes] = useState(false);

	const colunasIniciais = {
		Descrição: "",
		Status: "",
		Qtde: "",
		Valor: "",
		Data: "",
		Autorização: "",
		Origem: "",
		Motivo: "",
	};

	const [listMovimentacao, setListMovimentacao] = useState([]);
	const [recordCount, setRecordCount] = useState("");

	useEffect(() => {
		const agora = new Date();
		const dataFormatada = functions.dateToStrIso(agora);
		setDtIni(dataFormatada);
		setDtFim(dataFormatada);
	}, []);

	function openFilter() {
		setIsFilterOpen(!isFilterOpen);
	}

	function closeFilter() {
		setIsFilterOpen(false);
	}

	const listarReceivePayments = () => {
		let dataini = functions.dateByString(dtini);
		let datafim = functions.dateByString(dtfim);

		dataini = dataini + " " + hrIni;
		datafim = datafim + " " + hrFim;

		setIsFilterOpen(!isFilterOpen);

		const tipo = isSelectCaixa ? "caixa" : "colaborador";
		const valorTipo = idCaixaOuColaborador;

		listarMovimentacao(tipo, valorTipo, dataini, datafim);
	};

	const listarMovimentacao = async (param, paramValue, paramDtIni, paramDtFim) => {
		try {
			setLoading(true);

			const [responseDeletadosPdv, responseDeletadosGestor] = await Promise.all([
				reqProdutoPdv.listDeleted(param, paramValue, paramDtIni, paramDtFim),
				reqPedidoItens.listDeleted(param, paramValue, paramDtIni, paramDtFim),
			]);

			const listPdv = responseDeletadosPdv.data.map((mov) => {
				const dataMovimentacao = functions.dateTimeToStrIso8601(mov.data);
				const valor = functions.strToCurrency(mov.valor);
				// const dataPgto = functions.dateToStrIso8601(mov.datapgto);
				const avista = mov.avista ? `R$ ${mov.avista}` : "";
				// const aprazo = mov.aprazo ? `R$ ${mov.aprazo}` : "";
				return {
					Descrição: mov.descricao,
					Status: mov.status,
					Qtde: mov.qtde,
					Valor: valor,
					Data: dataMovimentacao,
					Autorização: mov.autorizacao,
					Origem: "PDV",
					Motivo: "",
				};
			});

			const listGestor = responseDeletadosGestor.data.map((mov) => {
				const dataMovimentacao = functions.dateTimeToStrIso8601(mov.dataalteracao);
				const valor = functions.strToCurrency(mov.valortotal);
				// const dataPgto = functions.dateToStrIso8601(mov.datapgto);
				const avista = mov.avista ? `R$ ${mov.avista}` : "";
				// const aprazo = mov.aprazo ? `R$ ${mov.aprazo}` : "";
				return {
					Descrição: mov.descricao,
					Status: "DEL",
					Qtde: mov.qtde,
					Valor: valor,
					Data: dataMovimentacao,
					Autorização: mov.funcionario,
					Origem: "Gestor de Pedidos",
					Motivo: mov.motivocancelamento,
				};
			});

			const combinedList = listPdv.concat(listGestor);

			listGestor?.length > 0 ? setOnObservacoes(true) : setOnObservacoes(false);

			setRecordCount(listPdv.length + listGestor.length);

			setListMovimentacao(combinedList);
		} catch (error) {
			Notification.showToast({ message: error.message, type: "warning" });
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="mt-page">
			<ToastContainer />
			<FilterModal //
				title={"Produtos deletados"}
				isOpen={isFilterOpen}
				onRequestClose={closeFilter}
				filterName={false}
				filterLate={false}
				dataEHora={true}
				dtini={dtini}
				dtfim={dtfim}
				hrIni={hrIni}
				hrFim={hrFim}
				idCaixaOuColaborador={idCaixaOuColaborador}
				isSelectCaixa={isSelectCaixa}
				setHrIni={setHrIni}
				setHrFim={setHrFim}
				setDtIni={setDtIni}
				setDtFim={setDtFim}
				setIdCaixaOuColaborador={setIdCaixaOuColaborador}
				setIsSelectCaixa={setIsSelectCaixa}
				handleList={listarReceivePayments}
				setNomeOuColaborador={setNomeOuColaborador}
				hideToggle={true}
			/>

			{/* HEADER PADRONIZADO */}
			<header className="flex flex-col bg-white p-2 rounded-sm box-shadow-md mb-6">
				<div className="grid grid-cols-2">
					<div className="col-span-1">
						<HeaderReport title="Produtos Deletados" subTitle={`PDV ${nomeColaboradorOuCaixa}`} />
					</div>
					<div className="col-span-1 flex justify-end mb-2">
						<div className="flex flex-col gap-1">
							<HeaderListFilter
								filterData={{
									origem: {
										label: "Pesquisar por",
										value: "Número do caixa",
									},
									periodo: {
										label: "Período",
										value: `${functions.dateByString(dtini)} à ${functions.dateByString(dtfim)}`,
									},
									registros: {
										label: "Registros encontrados",
										value: recordCount || "0",
									},
								}}
							/>
						</div>
					</div>
				</div>

				<div className="col-span-1 flex justify-end items-end mt-2">
					<div className="flex gap-2 h-8">
						<button className="btn btn-sm btn-primary w-32" onClick={openFilter}>
							Filtrar
						</button>
					</div>
				</div>
				<div className="border-bottom mt-3"></div>
			</header>

			<div className="w-full">
				<TabelaSimples list={listMovimentacao} loading={loading} columns={Object.keys(colunasIniciais)} />
			</div>

			{onObservacoes && (
				<small className="text-secondary">
					* Produtos deletados Gestor de pedidos não leva em consideração o número do caixa
				</small>
			)}
		</div>
	);
}

export default ProdutosDeletados;
